// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607301204/js/" + chunkId + "." + {"44":"073fe7c6","225":"74401545","481":"a930084f","486":"506c542d","770":"c8ae70f5"}[chunkId] + ".0.299416122862163.chunk.js";
};